import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'

gsap.registerPlugin(ScrollTrigger)

Array.from(document.querySelectorAll('[data-icon-cloud]')).forEach((iconCloud) => {
    ScrollTrigger.batch('[data-icon-cloud-block]', {
        start: 'top bottom-=200',
        onEnter: (batch) => gsap.fromTo(batch, {
            autoAlpha: 0,
            y: 25,
        }, {
            autoAlpha: 1,
            y: 0,
            stagger: 0.2,
        }),
        once: true,
    })
})
